(function () {
    "use strict";

    angular
        .module("PWAPoCApp")
        .controller("SupportController", supportController);

    supportController.$inject = ["$scope", "$kWindow", 'translateService', '$rootScope'];

    function supportController($scope, $kWindow, translateService, $rootScope) {
        $scope.sendReport = sendReport;
        $scope.openDiagPanel = openDiagPanel;
        $scope.translate = translateService.translate;
        $scope.toggleDepugPanel = toggleDepugPanel;

        function sendReport() {
            $kWindow.open({
                options: {
                    modal: true,
                    title: translateService.translate('support.sendReport'),
                    draggable: false,
                    movable: false,
                    resizable: false,
                    visible: false,
                    height: 250,
                    width: 350,
                },
                templateUrl: "app/support/send-report-view.html",
                windowTemplateUrl: "app/shared/modal-base.html",
                controller: "SendReportController",
            });
        }

        function openDiagPanel() {
            $kWindow.open({
                options: {
                    modal: true,
                    title: translateService.translate('support.diagnosticsPanel'),
                    draggable: false,
                    movable: false,
                    resizable: false,
                    visible: false,
                    height: "50%", //strange, but in reality it's about 90%
                    width: "95%",
                },
                templateUrl: "app/diagnostics/diagnostics-modal-view.html",
                windowTemplateUrl: "app/shared/modal-base.html",
                controller: "diagnosticsModalController",
            });
        }

        function toggleDepugPanel() {
            $rootScope.debugPanelVisible = !$rootScope.debugPanelVisible;
        }
    }
})();
